/**
 * The Paisa mark and palette: the one place to change the logo. Everything else (components on web, admin, phone and
 * docs, every favicon/icon/logo file, OG and store images) reads from here; `bun run brand` rewrites the files.
 * Spec: docs/design/brand-marks.md.
 */

/** The ₹ with its bowl removed: two bars and a swept leg, on a 16-unit box. */
export const MARK = {
  box: 16,
  stroke: 2.6,
  bars: [
    { x: 2, y: 1, width: 12, height: 2.6, rx: 1.3 },
    { x: 2, y: 5, width: 12, height: 2.6, rx: 1.3 },
  ],
  leg: "M3.3 6.3 C3.3 10.6, 6 12.6, 13.4 14.1",
  /** Ink bounds (round caps included), used to align and centre lockups. */
  ink: { left: 2, right: 14.7, top: 1, bottom: 15.4 },
} as const

export const COLORS = {
  fern: "#0b7a5a",
  fernDark: "#2fbf8f",
  ink: "#171b21",
  inkDark: "#edf0f4",
  paper: "#f1f5f2",
  /** Launcher icon "Runway" (phone default) and the OG/store graphics. */
  runway: "#3ddc9f",
  night: "#0a0f0c",
} as const
